import React from 'react';
import { fmtDate } from '../lib/share';

const Row = ({ k, v }) => (
  <div className="flex justify-between gap-3 border-b border-dashed border-slate-200 py-1 text-xs"><span className="text-slate-500">{k}</span><span className="font-semibold text-slate-800 text-right">{v || '—'}</span></div>
);

// Tarjeta de inscripción de cliente (imprimible)
export const ClientCard = ({ client }) => {
  const print = () => {
    // Impresión segura usando iframe (en lugar de document.write + popup, que es un vector XSS si client.* trae HTML).
    // Clonamos el nodo React-rendered como texto DOM, nunca concatenamos HTML del usuario.
    const sourceNode = document.getElementById('client-card-print');
    if (!sourceNode) return;
    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
    document.body.appendChild(iframe);
    const doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open();
    // Escribimos solo HTML estático (cabecera) y luego añadimos el nodo clonado, sin inyectar strings del usuario.
    doc.write('<!doctype html><html><head><meta charset="utf-8"><title>Tarjeta</title><link rel="stylesheet" href="' + window.location.origin + '/static/css/main.css"></head><body style="font-family:Arial;padding:24px"></body></html>');
    doc.close();
    doc.body.appendChild(sourceNode.cloneNode(true));
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => iframe.remove(), 1000);
    }, 350);
  };
  return (
    <div>
      <div id="client-card-print">
        <div style={{ border: '2px solid #022C22', borderRadius: 14, overflow: 'hidden', maxWidth: 640 }} data-testid="client-registration-card">
          <div style={{ background: '#022C22', color: '#FFC857', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div><div style={{ fontWeight: 900, fontSize: 18 }}>{(client.tenant_brand || client.company_name || 'SalesPRO').toUpperCase()}</div><div style={{ fontSize: 11, color: '#fff' }}>Tarjeta de inscripción de cliente</div></div>
            {client.tenant_logo ? <img src={client.tenant_logo} alt="" style={{ height: 44, borderRadius: 8, background: '#fff' }} /> : null}
          </div>
          <div style={{ padding: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 18 }}>
            <div>
              <p style={{ fontWeight: 800, fontSize: 12, color: '#022C22', marginBottom: 4 }}>DATOS DEL CLIENTE</p>
              <Row k="Nombre" v={client.name} /><Row k="Cédula/RIF" v={client.cedula_rif} /><Row k="Teléfono" v={client.phone} />
              <Row k="Correo" v={client.email} /><Row k="Nacimiento" v={client.birth_date ? fmtDate(client.birth_date) : ''} />
              <Row k="Dirección" v={client.address} /><Row k="Ocupación" v={client.occupation} /><Row k="Lugar de trabajo" v={client.workplace} />
              <Row k="Ingreso mensual" v={client.monthly_income} />
            </div>
            <div>
              <p style={{ fontWeight: 800, fontSize: 12, color: '#022C22', marginBottom: 4 }}>CONTACTOS DE REFERENCIA</p>
              <Row k={`1 · ${client.contact1_relation || 'Contacto'}`} v={`${client.contact1_name || ''} ${client.contact1_phone || ''}`} />
              <Row k={`2 · ${client.contact2_relation || 'Contacto'}`} v={`${client.contact2_name || ''} ${client.contact2_phone || ''}`} />
              <p style={{ fontWeight: 800, fontSize: 12, color: '#022C22', margin: '12px 0 4px' }}>CRÉDITO</p>
              <Row k="Estado" v={client.credit_status} /><Row k="Límite aprobado" v={`$${Number(client.credit_limit_approved || 0).toFixed(2)}`} />
              <Row k="Sucursal" v={client.company_name} /><Row k="Inscrito" v={fmtDate(client.created_at)} />
              <div style={{ marginTop: 28, borderTop: '1px solid #334155', fontSize: 10, textAlign: 'center', paddingTop: 4 }}>Firma del cliente</div>
            </div>
          </div>
        </div>
      </div>
      <button onClick={print} data-testid="print-client-card" className="mt-2 text-xs px-3 py-1.5 rounded-md bg-[#022C22] text-white">Imprimir tarjeta</button>
    </div>
  );
};

export default ClientCard;
